import { Card as AntdCard, type CardProps as AntdCardProps } from 'antd';
import { type ElementRef, forwardRef } from 'react';

type CardProps = Omit<AntdCardProps, 'headStyle' | 'bodyStyles'>; // headStyle and bodyStyles are deprecated

export const Card = forwardRef<ElementRef<typeof AntdCard>, CardProps>(
  (props, ref) => {
    return <AntdCard ref={ref} {...props} />;
  },
);

Card.displayName = 'Card';
